import { useContext } from "react";

import ParcelStatusContext from "./ParcelStatusContext";

export const useParcelStatus = () => useContext(ParcelStatusContext);
